import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env';

@Injectable({
    providedIn: 'root'
})
export class GateService {
    constructor(
        private http: HttpClient,
    ) { }

    regenerateAccesstoken(memberId: number): Observable<generateAccessTokenResponse> {
        return this.http.post<generateAccessTokenResponse>(`${environment.apiUrl}gate/${memberId}/generate-access-token`, {});
    }

    regenerateIntrocardAccesstoken(): Observable<generateAccessTokenResponse> {
        return this.http.post<generateAccessTokenResponse>(`${environment.apiUrl}gate/introcard/generate-access-token`, {});
    }
}

export interface generateAccessTokenResponse {
    token?: string;
    expires_at?: string;
    seconds_left?: number;
    type?: string;
    error?: string;
}
